import { render, staticRenderFns } from "./Leveltest.vue?vue&type=template&id=67f0577b&scoped=true&"
import script from "./Leveltest.vue?vue&type=script&lang=js&"
export * from "./Leveltest.vue?vue&type=script&lang=js&"
import style0 from "./Leveltest.vue?vue&type=style&index=0&id=67f0577b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f0577b",
  null
  
)

export default component.exports